import React, { useEffect, useState } from "react";
import LOGO_COLOR from 'assets/images/logo-color.png';
import LOGO_WHITE from 'assets/images/logo-white.png';
import ICON_MENU from 'assets/images/icon-menu.svg';
import ICON_MENU_COLOR from 'assets/images/icon-menu-color.svg';
import ICON_MENU_CLOSE from 'assets/images/icon-menu-close.svg';
import './styles.scss';
import DATA from 'utils/data.json';


const Menu = () => {
    const [isShowing, setIsShowing] = useState(false);
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const getMenuIcon = (offset) => {
        if (isShowing) {
            return ICON_MENU_CLOSE
        }
        if (offset < 200) {
            return ICON_MENU
        }
        return ICON_MENU_COLOR
    }

    const onMenuItemClick = (item) => {
        setIsShowing(false)
        let el = document.getElementById(item.link)
        if (el) {
            window.scrollTo({left: 0, top: el.offsetTop - (80), behavior: 'smooth'})
        }
    }

    return (
        <div className={'menu-container'}>
            <div className={`menu ${isShowing ? 'showing' : ""}`} style={{ background: `rgba(255, 255, 255, ${offset / 400})` }}>
                <a href={'/'}>
                    {offset < 200 && !isShowing ?
                        <img alt='' src={LOGO_WHITE} className={'logo'} />
                        :
                        <img alt='' src={LOGO_COLOR} className={'logo'} />
                    }
                </a>

                <button onClick={() => setIsShowing(!isShowing)} className='menu-button'>
                    {offset < 200 && !isShowing ?
                        <img alt='' src={getMenuIcon(offset)} className={'menu-icon'} />
                        :
                        <img alt='' src={getMenuIcon(offset)} className={'menu-icon'} />
                    }
                </button>
            </div>

            <div className={`content ${isShowing ? 'showing' : ""}`}>
                {DATA['nav-item'].map(item => {
                    return (
                        <button style={{background: 'transparent'}} key={item.id} onClick={() => onMenuItemClick(item)} >
                            {offset < 200 ? <p className={'item'}>{item.text}</p> : <p className={'item-black'}>{item.text}</p>}
                        </button>
                    )
                })}
            </div>
        </div>
    )
}

export default Menu;